module.exports = __webpack_public_path__ + "img/airtasker.8ab511c9.png";